import React from "react";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import Card from "@plum-xoxo/admin-dsm/core/card/Card";
import styled from "styled-components";
import { CircularLoader } from "@plum-xoxo/admin-dsm";
const StyledCard = styled(Card).attrs()`
  background: ${(props) => props.theme.palette.light.c100} !important;
`;
const BillingDetails = (props) => {
  const companyDetails = props.accountReducer?.companyDetails;
  return (
    <div className="d-flex flex-column mt-16" style={{ width: "400px" }}>
      <StyledCard className="d-flex flex-column p-24 box">
        <Typography.HelperText>Billing Details</Typography.HelperText>
        {props.isLoading ? (
          <CircularLoader className="mt-12" />
        ) : (
          <div className="d-flex flex-column mt-12">
            <Typography.HelperText component="div" color="dark" shade="c200">
              Name:&nbsp;
              <Typography.HelperText component="span" color="dark" shade="c200">
                {props.accountReducer?.companyDetails?.company_name}
              </Typography.HelperText>
            </Typography.HelperText>
            <Typography.HelperText component="div" color="dark" shade="c200">
              Country: &nbsp;
              <Typography.HelperText component="span" color="dark" shade="c200">
                {props.accountReducer?.companyDetails?.tax_country_code}
              </Typography.HelperText>
            </Typography.HelperText>
            <Typography.HelperText component="div" color="dark" shade="c200">
              Identification Number:&nbsp;
              <Typography.HelperText component="span" color="dark" shade="c200">
                {props.accountReducer?.companyDetails?.company_tax_id}
              </Typography.HelperText>
            </Typography.HelperText>

            <Typography.HelperText component="div" color="dark" shade="c200">
              Address:&nbsp;
              <Typography.HelperText component="span" color="dark" shade="c200">
                <span>
                  {companyDetails && companyDetails.company_address1
                    ? companyDetails.company_address1 + ","
                    : null}
                  {companyDetails && companyDetails.company_city_name
                    ? companyDetails.company_city_name + ", "
                    : null}{" "}
                  {companyDetails && companyDetails.company_state_name
                    ? companyDetails.company_state_name + ", "
                    : null}
                  {companyDetails && companyDetails.company_country_name
                    ? companyDetails.company_country_name
                    : null}{" "}
                  {companyDetails && companyDetails.company_zip_code
                    ? +companyDetails.company_zip_code
                    : null}
                </span>
              </Typography.HelperText>
            </Typography.HelperText>
          </div>
        )}
      </StyledCard>
    </div>
  );
};
export default BillingDetails;
